var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8045 14.8623L11.8252 10.883C12.9096 9.55674 13.4428 7.8644 13.3144 6.15605C13.1861 4.4477 12.406 2.85403 11.1356 1.70469C9.86516 0.55535 8.20158 -0.0617289 6.48895 -0.0189077C4.77632 0.0239135 3.14566 0.723359 1.93426 1.93475C0.72287 3.14614 0.0234252 4.7768 -0.019396 6.48944C-0.0622172 8.20207 0.554862 9.86565 1.7042 11.1361C2.85354 12.4065 4.44721 13.1865 6.15556 13.3149C7.86392 13.4433 9.55625 12.9101 10.8825 11.8257L14.8619 15.805C14.9876 15.9264 15.156 15.9936 15.3308 15.9921C15.5056 15.9906 15.6728 15.9205 15.7964 15.7969C15.92 15.6733 15.9901 15.5061 15.9916 15.3313C15.9932 15.1565 15.926 14.9881 15.8045 14.8623ZM6.66652 12.0003C5.61169 12.0003 4.58054 11.6875 3.70348 11.1015C2.82642 10.5155 2.14283 9.68253 1.73916 8.70799C1.3355 7.73345 1.22988 6.66109 1.43567 5.62653C1.64145 4.59196 2.14941 3.64165 2.89529 2.89577C3.64117 2.14989 4.59147 1.64194 5.62604 1.43615C6.6606 1.23037 7.73296 1.33598 8.7075 1.73965C9.68204 2.14332 10.515 2.82691 11.101 3.70397C11.6871 4.58103 11.9999 5.61218 11.9999 6.66701C11.9983 8.08101 11.4359 9.43664 10.436 10.4365C9.43615 11.4363 8.08052 11.9988 6.66652 12.0003Z",
    fill: "#9E9E9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a8d7e420d90484fbf2fb83daa23a5fa4.svg";
export { ForwardRef as ReactComponent };